import { ICarentsTotals } from "Dashboard/scenes/Carnets/domain/ICarnetsTotals";

interface IProps {
  totals: ICarentsTotals;
}

const CarnetsFooter = ({ totals }: IProps) => {
  return (
    <div
      className="row"
      style={{ "--carnet-hour-columns": totals.hoursTotals.length } as React.CSSProperties}
    >
      <div></div>
      <div></div>
      <div></div>
      {totals.hoursTotals && totals.hoursTotals.map(hoursItem =>
      (<div className="col center strong" key={hoursItem.index}>
        <div className="bg-item-border">{hoursItem.hours}</div>
      </div>)
      )}
      <div className="col center strong">
        <div className="bg-item-border">{totals.regularBreakfastsTotal}</div>
        <div className="bg-item-border">{totals.regularLunchesTotal}</div>
        <div className="bg-item-border">{totals.regularDinnersTotal}</div>
      </div>
      <div className="col center strong">
        <div className="bg-item-border">{totals.cashBreakfastsTotal}</div>
        <div className="bg-item-border">{totals.cashLunchesTotal}</div>
        <div className="bg-item-border">{totals.cashDinnersTotal}</div>
      </div>
      <div className="col center strong">
        <div className="bg-item-border">{totals.sickLeavesTotal}</div>
      </div>
      <div className="col center strong">
        <div className="bg-item-border">{totals.vacationsTotal}</div>
      </div>
      <div></div>
    </div>
  );
};

export default CarnetsFooter;
